import { Table } from 'app/components/table/table';
import { AggregrationType, ITableColumn, TableModel } from 'app/components/table/table.model';
import { useStore } from 'app/context';
import { AgtAkumaPlanerVM, AkumaPlanerArtSchema } from 'app/stores/ui/agt.akumaplaner.ui.store';
import { formatKw, formatNum, formatPercent } from 'app/utils';
import { observer } from 'mobx-react';
import { useEffect, useMemo, useState } from 'react';
import _ from 'lodash';
import { AkumaPlanerOptions } from './AkumaPlanerListe';
import { AkumaPlanerKWModel, IAkumaPlanerValues } from 'app/stores/kv.agentur.year.akumaplaner.store';
import { AkumaPlanerWochenChart } from './AkumaPlanerWochenChart';

export const AkumaPlanerWochenbericht = observer(() => {
	const { berichteUiiStore, agtAkumaPlanerUiStore, agenturListUiStore } = useStore();
	const [groupedByKw, setGroupedByKw] = useState<IAkumaPlanerValues[]>();

	const tm = useMemo(() => {
		const tm = new TableModel<IAkumaPlanerValues, number>();
		const cols: ITableColumn<IAkumaPlanerValues, number>[] = [];

		cols.push({
			label: 'KW',
			path: 'bm',
			sortBy: 'bm',
			format: formatKw,
		});

		cols.push({
			label: 'Quote Übertragung',
			path: 'quote',
			render: (row) => {
				const q = (row.data.zu / row.data.gesamt) * 100;
				return <>{formatPercent(q, 1)}%</>;
			},
			agg: [
				{
					path: `quote`,
					aggType: AggregrationType.avg,
					render: (tm: TableModel<IAkumaPlanerValues, number>, aggValue?: number) => {
						const zu = tm.data.map((d) => d.zu).reduce((a, b) => a + b, 0);
						const gesamt = tm.data.map((d) => d.gesamt).reduce((a, b) => a + b, 0);
						const q = (zu / gesamt) * 100;
						return <strong>{formatPercent(q, 1)}%</strong>;
					},
				},
			],
		});

		AkumaPlanerArtSchema.forEach((art) => {
			if (art.path === 'gpWochen') {
				return;
			}
			cols.push({
				label: art.label,
				path: `${art.path}`,
				format: formatNum,
				agg: [
					{
						path: `${art.path}`,
						aggType: AggregrationType.sum,
					},
				],
			});
		});

		tm.sortBy = 'bm';
		tm.setCols(cols);

		tm.idProperty = 'bm';
		tm.idType = 'number';

		return tm;
	}, []);

	useEffect(() => {
		const loadData = async () => {
			// Ensure base data is loaded first (this populates kws, minKw, maxKw)
			await agtAkumaPlanerUiStore.load();
			const agtIdsFilter = berichteUiiStore.selectedAgtFilter.length > 0 ? berichteUiiStore.selectedAgtFilter : agenturListUiStore.filteredAgtIdsAsFilter;
			const items = await agtAkumaPlanerUiStore.agtAkumaPlanerStore.aggregateByKw(agtAkumaPlanerUiStore.minKwCurrent, agtAkumaPlanerUiStore.maxKwCurrent, agtIdsFilter);

			setGroupedByKw(items);
			tm.setRowData(items);
			tm.sort();
		};

		loadData();
	}, [
		tm,
		berichteUiiStore.selectedAgt,
		agenturListUiStore.filterHasChanged,
		agenturListUiStore,
		agtAkumaPlanerUiStore.items,
		agtAkumaPlanerUiStore.allVmItems,
		agtAkumaPlanerUiStore.currentKWItems,
		agtAkumaPlanerUiStore.maxKwCurrent,
		agtAkumaPlanerUiStore.minKwCurrent,
		agtAkumaPlanerUiStore.kws,
		agtAkumaPlanerUiStore,
	]);

	return (
		<>
			<div className="table-container pad-bottom-3rem">
				<AkumaPlanerOptions />
				<div className="table-container">
					{groupedByKw && <AkumaPlanerWochenChart data={groupedByKw} />}
					<Table modifier="page-break-avoid" stickyHeader={true} tm={tm}></Table>
				</div>
			</div>
		</>
	);
});
